var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"popup-post-viewer",attrs:{"title":_vm.title,"active":_vm.showPopup},on:{"update:active":function($event){_vm.showPopup=$event}}},[_c('div',{staticClass:"popup-post-viewer-container"},[_c('div',{staticClass:"p-6 overflow-y-auto"},[_c(_vm.componentWrite,_vm._b({tag:"component",staticClass:"w-full h-full",attrs:{"_postId":`${_vm.postId}`,"parentId":_vm.parentId,"board":{
            projectTitle: '',
            writer: {}, //작성자 정보
            readonly: true, // 읽기전용인가
            viewSaveBtn: false,
          },"header":_vm.header,"value":_vm.body}},'component',_vm.options,false))],1),_c('div',[_vm._t("foot",null,{"close":() => { _vm.showPopup = false }})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }